import { Input } from '@/components/common/Input'
import { Select } from '@/components/common/Select'
import { Textarea } from '@/components/common/Textarea'
import { StepShell, StepGrid } from '../StepShell'
import { GENDER_OPTIONS } from '@/lib/constants'

const DEFAULT = {
  name: '',
  dob: '',
  gender: '',
  mobile_number: '',
  whatsapp_number: '',
  address: '',
  occupation: '',
  referred_by: '',
}

export function PatientDetailsStep({ value, onChange, errors = {} }) {
  const v = { ...DEFAULT, ...(value || {}) }
  const set = (patch) => onChange?.({ ...v, ...patch })

  return (
    <StepShell
      eyebrow="Phase 1"
      title="Patient details"
      description="Personal information. A unique patient ID (e.g. RD000PT001) is auto-assigned on save."
    >
      <StepGrid>
        <Input
          label="Full name"
          required
          name="name"
          value={v.name}
          onChange={(e) => set({ name: e.target.value })}
          placeholder="e.g. Harshini P"
          error={errors.name}
          className="sm:col-span-2"
        />
        <Input
          label="Date of birth"
          required
          type="date"
          name="dob"
          value={v.dob}
          onChange={(e) => set({ dob: e.target.value })}
          error={errors.dob}
          max={new Date().toISOString().slice(0, 10)}
        />
        <Select
          label="Gender"
          required
          name="gender"
          value={v.gender}
          onChange={(e) => set({ gender: e.target.value })}
          placeholder="Select gender"
          options={GENDER_OPTIONS}
          error={errors.gender}
        />
        <Input
          label="Mobile number"
          required
          name="mobile_number"
          inputMode="numeric"
          value={v.mobile_number}
          onChange={(e) => set({ mobile_number: e.target.value })}
          placeholder="10 digits"
          error={errors.mobile_number}
        />
        <Input
          label="WhatsApp number"
          name="whatsapp_number"
          inputMode="numeric"
          value={v.whatsapp_number}
          onChange={(e) => set({ whatsapp_number: e.target.value })}
          placeholder="Same as mobile if blank"
          error={errors.whatsapp_number}
        />
        <Input
          label="Occupation"
          name="occupation"
          value={v.occupation}
          onChange={(e) => set({ occupation: e.target.value })}
          placeholder="e.g. Teacher"
        />
        <Input
          label="Referred by"
          name="referred_by"
          value={v.referred_by}
          onChange={(e) => set({ referred_by: e.target.value })}
          placeholder="Doctor / friend / walk-in"
        />
        <Textarea
          label="Address"
          name="address"
          value={v.address}
          onChange={(e) => set({ address: e.target.value })}
          placeholder="House no, street, city"
          className="sm:col-span-2"
          rows={2}
        />
      </StepGrid>
    </StepShell>
  )
}
